<template>
  <div style="width:100%;float:left;">
    <CCard>
      <CCardHeader>User Profile</CCardHeader>
      <CCardBody>
        <div style="width:100%;float:left;" v-if="user">
          <CInput
            label="Name"
            v-model="user.name"
            />
          <CInput
            label="Email"
            v-model="user.email"
            disabled
            />
          <div>
          <CInput
            label="Additional Emails To Be Sent w/ Order Confirmation (separate by comma)"
            v-model="user.additional_emails"
            />
            <label>Timezone</label><br />
            <select class="form-control" style="width:250px;" v-model="user.timezone">
              <option value="CST">CST</option>
              <option value="EST">EST</option>
              <option value="HST">HST</option>
              <option value="MST">MST</option>
              <option value="PST">PST</option>
            </select>
          </div>
          <!-- <div style="margin-top:15px;">
            <label>Receive Emails?</label><br />
            <CButton size="sm" :color="user.get_emailed ? 'info' : 'outline-info'" @click="user.get_emailed = 1">Yes</CButton>
            <CButton size="sm" class="ml-2" :color="!user.get_emailed ? 'info' : 'outline-info'" @click="user.get_emailed = 0">No</CButton>
          </div> -->
          <div style="margin-top:15px;">
            <label>Receive email when order is submitted?</label><br />
            <CButton size="sm" :color="user.email_when_order_submitted ? 'success' : 'outline-success'" @click="user.email_when_order_submitted = 1">Yes</CButton>
            <CButton size="sm" class="ml-2" :color="!user.email_when_order_submitted ? 'danger' : 'outline-danger'" @click="user.email_when_order_submitted = 0">No</CButton>
          </div>
          <div style="margin-top:15px;">
            <label>Receive email when order is shipped?</label><br />
            <CButton size="sm" :color="user.email_when_order_shipped ? 'success' : 'outline-success'" @click="user.email_when_order_shipped = 1">Yes</CButton>
            <CButton size="sm" class="ml-2" :color="!user.email_when_order_shipped ? 'danger' : 'outline-danger'" @click="user.email_when_order_shipped = 0">No</CButton>
          </div>
          <div style="margin-top:15px;">
            <label style="width:100%;float:left;margin-bottom:0px;">Receive email when there's a new chat/order notification?</label><br />
            <!-- <label style="color:red;font-size:12px;width:100%;float:left;padding-top:0px;">(This can not be turned off, if you think it should please let someone know why you need it off)</label><br /> -->
            <CButton size="sm" :color="user.notification_email ? 'success' : 'outline-success'" @click="user.notification_email = 1">Yes</CButton>
            <!-- <CButton size="sm" class="ml-2" :color="!user.notification_email ? 'danger' : 'outline-danger'" @click="user.notification_email = 0">No</CButton> -->
          </div>

          <spacer />
          <CButton @click="save()" size="sm" color="primary">Save</CButton>
        </div>
        <small-loader v-else></small-loader>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
var methods = {}

methods.getUser = function () {
  axios.get(this.$apiAdress + '/api/getUserInfo/' + this.$store.state.user.id + '?token=' + localStorage.getItem('api_token')).then(response => {
    console.log('get user')
    console.log(response)
    this.user = response.data
  })
}

methods.save = function () {
  const postData = {
    user: this.user
  }
  axios.post(this.$apiAdress + '/api/saveUser?token=' + localStorage.getItem('api_token'), this.user).then(response => {
    Swal.fire({
      type: 'success',
      title: 'Success!',
      text: 'You have saved your user settings.'
    })
  })
}

export default {
  // ===Component name
  name: "Profile",
  // ===Props passed to component
  props: {},
  // ===Components used by this component
  components: {

  },
  // ====component Data properties
  data(){
      return{
        user: null,
        // questions: [
        //   {
        //     label: 'Receive Emails?',
        //     field: 'get_emailed'
        //   },
        //   {
        //     label: 'Receive email when order is submitted?',
        //     field: 'email_when_order_submitted'
        //   },
        //   {
        //     label: 'Receive email when there is a new notification?',
        //     field: 'notification_email'
        //   },
        //   {
        //     label: 'Receive Emails?',
        //     field: 'get_emailed'
        //   },
        // ]
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    this.getUser()
  },
  // ===Computed properties for the component
  computed: {},
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
